import { SOCIAL_METRICS, getScoreColor } from '../utils/scoring';
import TickSlider from './TickSlider';

export default function SocialProofCard({ data, onChange }) {
  const safeData = { ...data };

  if (safeData.presenceScore !== undefined && typeof safeData.presenceScore === 'number') {
    SOCIAL_METRICS.forEach(m => {
      if (safeData[m.id] === undefined) safeData[m.id] = safeData.presenceScore || 5;
    });
  }

  const metricValues = SOCIAL_METRICS.map(m => safeData[m.id] || 5);
  const avgScore = metricValues.reduce((s, v) => s + v, 0) / metricValues.length;
  const avgColor = getScoreColor(avgScore);

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h3 className="font-display text-lg text-white">Social Proof Scorecard</h3>
          <p className="text-xs text-neutral-500 mt-0.5">Content quality, engagement, and organic reach</p>
        </div>
        <div className={`w-14 h-14 rounded-xl ${avgColor.bg} flex items-center justify-center`}>
          <span className={`text-xl font-black ${avgColor.text}`}>{avgScore.toFixed(1)}</span>
        </div>
      </div>

      {/* Real Instagram metrics if available */}
      {(safeData.followers || safeData.engagementRate) && (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-5">
          {safeData.followers && (
            <div className="bg-neutral-800/40 rounded-lg p-3 text-center">
              <p className="text-lg font-bold text-white">{typeof safeData.followers === 'number' ? safeData.followers.toLocaleString() : safeData.followers}</p>
              <p className="text-[10px] text-neutral-500">Followers</p>
            </div>
          )}
          {safeData.engagementRate && (
            <div className="bg-neutral-800/40 rounded-lg p-3 text-center">
              <p className="text-lg font-bold text-brand-gold">{safeData.engagementRate}</p>
              <p className="text-[10px] text-neutral-500">Engagement</p>
            </div>
          )}
          {safeData.postingFrequency && (
            <div className="bg-neutral-800/40 rounded-lg p-3 text-center">
              <p className="text-sm font-bold text-white">{safeData.postingFrequency}</p>
              <p className="text-[10px] text-neutral-500">Posting</p>
            </div>
          )}
          {safeData.contentQuality && (
            <div className="bg-neutral-800/40 rounded-lg p-3 text-center">
              <p className="text-sm font-bold text-white">{safeData.contentQuality}</p>
              <p className="text-[10px] text-neutral-500">Content</p>
            </div>
          )}
        </div>
      )}

      {/* Editable notes */}
      <div className="mb-5">
        <textarea
          value={safeData.notes || ''}
          onChange={(e) => onChange({ ...safeData, notes: e.target.value })}
          placeholder="Add social proof observations, notes on content quality, engagement patterns..."
          rows={3}
          className="input-field text-sm"
        />
      </div>

      <div className="space-y-4">
        {SOCIAL_METRICS.map((metric) => {
          const val = safeData[metric.id] || 5;
          const color = getScoreColor(val);
          return (
            <div key={metric.id}>
              <div className="flex justify-between items-center mb-1">
                <span className="text-sm text-neutral-300">{metric.name}</span>
                <span className={`text-sm font-bold ${color.text}`}>{val.toFixed(1)}</span>
              </div>
              <TickSlider value={val} onChange={(v) => onChange({ ...safeData, [metric.id]: v })} />
            </div>
          );
        })}
      </div>
    </div>
  );
}
